import React from "react";
import { Link } from "react-router-dom";
import styled from 'styled-components'
import arrow from '../assets/link.png'

const Init = () => {
  return (
    <InitContainer>
      <SubTitle>Continental Car & Van tires</SubTitle>
      <Title>How would you like to search</Title>
      <LinkContainer>
        <StyledLink to="/" >Search by size</StyledLink>
        <br />
        <br />
        <StyledLink to="/searchbyphoto" >Search by photo</StyledLink>
      </LinkContainer>

      <Button to="/alltires">
        <p>All tires</p>
      </Button>
    </InitContainer>
  );
}

const InitContainer = styled.div`
    width: 90%;
    padding-top: 50px;
    margin: 0 auto;
    text-align: center;
`
const SubTitle = styled.p`
    font-family: ContinentalMedium;
    font-size: 16px;
    margin-bottom: 5px;
`
const Title = styled.p`
    font-family: ContinentalMedium;
    width: 268px;
    margin: 0 auto;
    font-size: 30px;
    line-height: 38px;
    margin-bottom: 40px;
`
const LinkContainer = styled.div`
    margin-bottom: 218px;
`
const StyledLink  = styled(Link)`
    font-size: 26px;
    line-height: 32px;
    margin-bottom: 20px;
    color: black;
    text-decoration: none;
    &:after {
        background-image: url(${arrow});
        background-size: 7px 13px;
        display: inline-block;
        width: 7px; 
        height: 13px;
        content:"";
        margin-left: 20px;
    }
`;
const Button = styled(Link)`
    width: 250px;
    height: 50px;
    border: 2px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    font-family: ContinentalMedium;
    font-size: 18px;
    letter-spacing: 0.005em;
    color: black;
    text-decoration: none;
`
export default Init;